export { default } from "ember-page-title/services/page-title";
